import { paginatedQuery } from 'lib-shared-api-utils';

import { api } from 'app/app.api';

import {
  ReadDefaultNumberApiResponse,
  ReadNumbersApiArg,
  ReadNumbersApiResponse,
  ReadValidateNumberApiArg,
  ReadValidateNumberApiResponse,
  UpdateNumberApiArg,
  UpdateNumberApiResponse,
} from './types/numbersApi.types';

export const numbersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readNumbers: builder.query<ReadNumbersApiResponse, ReadNumbersApiArg>({
      query: (arg) =>
        paginatedQuery(
          arg,
          ({ capability }) => ({
            version: 1,
            path: 'numbers',
            params: { sms_capable: capability === 'sms' ? 'true' : undefined },
          }),
          { pagination: { paramNaming: 'limitCount' } },
        ),
    }),
    readDefaultNumber: builder.query<ReadDefaultNumberApiResponse, void>({
      query: () => ({
        version: 1,
        path: 'numbers/default',
      }),
    }),
    readValidateNumber: builder.query<
      ReadValidateNumberApiResponse,
      ReadValidateNumberApiArg
    >({
      query: ({ phoneNumber }) => ({
        version: 1,
        path: `numbers/validate/${phoneNumber}`,
      }),
    }),
    updateNumber: builder.mutation<UpdateNumberApiResponse, UpdateNumberApiArg>(
      {
        query: ({ phoneNumber, data: body }) => ({
          version: 1,
          path: `numbers/${phoneNumber}`,
          method: 'PUT',
          body,
        }),
      },
    ),
  }),
});
